<template>
  <div class="list-wrap">
    <div class="con-wrap">
      <div class="top-wrap clear">
<!--        <el-carousel height="180px" class="fr">-->
<!--        <el-carousel-item v-for="item in imgArr" :key="item">-->
<!--          <img :src=item alt="">-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
        <el-carousel class="fr">
          <el-carousel-item v-for="item in imgArr" :key="item">
            <img :src=item alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="btn-box fl">
          <img class="fr backBtn" src="../../../assets/images/GIS/fanhui.png" alt="" @click="$router.go(-1)">
          <template  v-if="imgsList.length >= 12">
            <i :class="['iconfont', 'iconxiangmu2', 'fr', firstImgCol == 3 ? 'selected': '']" @click="firstImgCol = 3"></i>
            <i :class="['iconfont', 'iconxiaosuolvetu', 'fr', firstImgCol == 2 ? 'selected': '']" @click="firstImgCol = 2"></i>
          </template>
          <el-select v-model="companyId" @change="getCompanyImgs" class="fr w353 info-select company-select">
            <el-option v-for="item in companyList" :label="item.divisionName" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-select v-model="typeId" @change="getCompanyImgs" class="fr info-select">
            <el-option v-for="item in typeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-button class="fr gis-btn" @click="goPage('video3d',companyId)" v-if="companyId == 7||companyId == 6||companyId == 62">企业三维</el-button>
        </div>
        <!--        <h2 class="fr">{{companyName}}</h2>-->
<!--        <h2 class="fr sub-title">{{typeList[typeId - 1].name}}</h2>-->
      </div>
      <div class="img-wrap">
        <ul class="img-box clear">
          <li :class="['fl', 'clear', `item${imgsList.length}`, imgsList.length >= 12 ? 'mul-list' + firstImgCol : '']" v-for="item in imgsList" :key="item.id">
            <img :src="getMediaPath(item.view).url_S" alt="" @click="scaleImg(item.view)" v-show="!isVideo(item.view) && getMediaPath(item.view)" class="fl">
            <video
                :id="'myPlayer' + item.id"
                :src="getMediaPath(item.view)"
                controls
                playsInline
                webkit-playsinline
                autoplay
                muted
                @click="videoScale(item.view)"
                v-show="isVideo(item.view) && getMediaPath(item.view)"
                class="fl"
            >
            </video>
            <div v-show="!getMediaPath(item.view)" class="no-data-des fl">暂无画面</div>
            <p @click="goPage('companyInfo', item.id, item.level)" class="fl">{{item.divisionName}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!--图片放大-->
    <el-dialog
        class="attachment-wrap"
        title=""
        :visible.sync="scaleFlag"
        width="1141px"
        top="13vh"
        @close="closeDialog">
      <div class="decorate"></div>
      <div class="content-wrap">
        <div class="image-box" >
          <img :src="scaleUrl">
        </div>
      </div>
    </el-dialog>
  <!--视频放大-->
  <div class="camera-wrap">
    <div class="video-details-warp" @mousedown="move">
      <p>{{videoName}}</p>
      <!-- 视频窗口 -->
      <video id="myPlayer" :src=videoPath controls playsInline webkit-playsinline autoplay>
      </video>
      <span class="iconfont" @click="closeVideo">
        <i class="el-icon-close"></i>
      </span>
    </div>
  </div>
  </div>
</template>

<script>
import * as EZUIKit from "../../../assets/js/external/ezuikit";

export default {
    name: "companyImgList",
    data(){
      return{
        imgArr: [require('../../../assets/images/GIS/轮播图/ceec1.jpg'), require('../../../assets/images/GIS/轮播图/ceec2.jpg'),  require('../../../assets/images/GIS/轮播图/ceec3.jpg'),  require('../../../assets/images/GIS/轮播图/ceec4.jpg')],
        companyId: '',
        companyList: [],
        companyName: '',
        typeList:[
          {
            name: '企业总览',
            id: 1
          },
          {
            name: '企业正门',
            id: 2
          },
          {
            name: '企业值班室',
            id: 3
          },
          {
            name: '企业大厅',
            id: 4
          },
          {
            name: '企业主要生产车间',
            id: 5
          }
        ],
        typeId: 1,
        imgsList: [],
        scaleFlag: false,
        scaleUrl: '',
        videoPath: '',
        videoName: '',
        firstImgCol: 3
      }
    },
    watch: {
      imgsList( val ){
        if(this.typeId != 1){
          this.$nextTick(function() {
            for(let i in this.imgsList){
              let now = this.imgsList[i].view
              if(now[0] && now[0].url[0] && now[0].url[0].indexOf('m3u8') != -1){
                let nowVideo = new EZUIKit.EZUIPlayer("myPlayer" + this.imgsList[i].id);
                if(nowVideo){
                  nowVideo.on("play", function () {
                  });
                  nowVideo.on("error", function () {
                    console.log("error");
                  });
                }
              }
            }
          });
        }else{
          let videos = document.getElementsByTagName('video');
          videos.forEach((item)=>{
            item.src = '';
          })
        }
      },
      videoPath(val){
        this.$nextTick(function(){
          new EZUIKit.EZUIPlayer('myPlayer');
        })
      },
    },
    mounted() {
      this.getCompanyList();
    },
    beforeDestroy() {
      this.imgsList = [];
      this.videoPath = '';
    },
    methods:{
      getMediaPath( el ){
        return el[0] ? (el[0].url && el[0].url.length!==0 && el[0].url[0]!==null) ? el[0].url[0] : (el[0].url_S && el[0].url_S.length !==0) ? el[0] : '' : '';
      },
      isVideo( el ){
        let now = this.getMediaPath( el );
        return now ? typeof(now)=='string' ? true : false : false;
      },
      getCompanyList(){
        this.$get('gisoverview/getdivisionlist', [0])
        .then((res)=>{
          this.companyList = res;
          this.companyId = this.$route.query.id ? this.$route.query.id : res[0].id;
          this.getCompanyImgs();
        })
      },
      getCompanyImgs(){
        this.$get('gisoverview/getdivisionviewlist', [this.companyId, this.typeId, 1])
        .then((res)=>{
          this.imgsList = res;
          this.companyName = res[0].divisionName;
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求失败'
          })
        })
      },
      /*
      * 页面跳转
      * path 路由， companyId 公司id， level 公司级别
      * */
      goPage(path, companyId, level){
        let id = companyId ? companyId : this.companyId;
        if(level != 3){
          // if(path == 'video3d' && this.companyId != 7){
          //   return false;
          // }
          if(path == 'video3d'){
            // if( this.companyInfo.id != 7 ){
            //   return false;
            // }
            if(this.companyId == 6) {
              path = 'zhuangbei3d';
            } else if(this.companyId == 62) {
              path = 'nanjing3d';
            }
          }
          this.$router.push({path: `/`+path, query: {id: id,type: this.typeId}});
        }
      },
      //图片放大
      scaleImg( el ){
        this.scaleUrl = this.getMediaPath(el).url_M;
        this.scaleFlag = true;
      },
      closeDialog(){
        this.scaleUrl = '';
        this.scaleFlag = false;
      },
      // 视频放大
      videoScale( path ){
        // this.videoPath = path[0].url[0];
        this.videoPath = this.getMediaPath(path);
        document.querySelector('.camera-wrap').style.cssText = 'display:block';
      },
      move(e){
        let odiv = e.target;// 获取目标元素
        let close_btn = document.querySelector('.videoDetails-warp span');
        //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
        let x = e.clientX - odiv.offsetLeft;
        let y = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          // 获取拖拽元素的位置
          let left = e.clientX - x;
          let top = e.clientY - y;
          this.positionX = left;
          this.positionY = top;
          odiv.style.left = left + "px";
          odiv.style.top = top + "px";
        }
        // 为了防止 火狐浏览器 拖拽阴影问题
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null
        }
      },
      closeVideo(){
        document.querySelector('.camera-wrap').style.cssText = 'display:none';
      },
    }
  }
</script>

<style scoped lang="scss">
.list-wrap{
  height: calc(100vh - 100px);
  .con-wrap{
    height: 100%;
    padding-top: 15px;
    .top-wrap{
      height: 36%;
      width: 100%;
      text-align: right;
      //padding-top: 10px;
      position: relative;
      .el-carousel {
        width: 74%;
        height: 100%;
        margin-right: 65px;
        .el-carousel__item {
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .btn-box {
        width: 21%;
        .backBtn {
          display: block;
          width: 35px;
          height: 35px;
          cursor: pointer;
        }
        .company-select {
          display: inline-block;
          margin-bottom: 20px;
          margin-top: 60px;
          margin-left: 12px;
        }
      }
      h2{
        position: absolute;
        top: 10px;
        left: 0;
        width: 100%;
        text-align: center;
        height: 32px;
        line-height: 32px;
        font-size: 26px;
        letter-spacing: 2px;
        z-index:0;
        &.sub-title{
          font-size: 28px;
        }
      }
      .el-select, .el-button{
        position: relative;
        z-index: 10;
      }
      .el-button{
        margin-right: 10px;
        //border: 1px solid #68DBFF;
        //box-shadow: 0px 0px 4px 0px #68DBFF;
        //&:hover{
        //  //color: #00efef;
        //  @include font_color("font_chose_color_btn");
        //}
      }
      .iconfont{
        cursor: pointer;
        position: relative;
        z-index: 10;
        margin-right: 10px;
        margin-top: 4px;
        color: #666;
        &.iconxiangmu2{
          font-size: 22px;
        }
        &.selected{
          color: #199DFD;
        }
      }
    }
    h2{
      text-align: center;
      height: 30px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 33px;
    }
    .img-box{
      width: 100%;
      margin-top: 20px;
      text-align: center;
      li{
        text-align: center;
        padding: 1%;
        /*display: inline-block;*/
        width: 16.6%;
        //margin-top: 3vh;
        img, video{
          width: 100%;
          height: 17vh;
          //background: rgba(10, 14, 35, 0.5);
          background: #EEF0F5;
        }
        &.mul-list3{
          width: 25%;
          img, video, .no-data-des{
            width: 90%;
            height: 23vh;
            line-height: 23vh;
          }
        }
        &.item1{
          width: 50%;
          //margin: 8vh 25% auto;
          margin: 0 25% auto;
          img, video, .no-data-des{
            width: 100%;
            height: 43vh;
            line-height: 43vh;
          }
        }
        &.item2{
          width: 45%;
          margin: 0 2.5% auto;
          img, video, .no-data-des{
            width: 70%;
            height: 40vh;
            line-height: 40vh;
            margin: 0 15%;
          }
        }
        &.item3{
          width: 32%;
          margin: 0 0.6% auto;
          img, video, .no-data-des{
            width: 95%;
            height: 40vh;
            line-height: 40vh;
            margin: 0 2.4%;
          }
        }
        &.item4{
          width: 25%;
          //margin-top: 8vh;
          img, video, .no-data-des{
            width: 100%;
            height: 30vh;
            line-height: 30vh;
          }
        }
        &.item5{
          //margin-top: 8vh;
        }
        &.item5, &.item9, &.item10{
          width: 20%;
          img, video, .no-data-des{
            width: 100%;
            height: 25vh;
            line-height: 25vh;
          }
        }
        &.item6{
          width: 30%;
          img, video, .no-data-des{
            width: 80%;
            height: 25vh;
            line-height: 25vh;
            margin: 0 10%;
          }
        }
        &.item7, &.item8{
          width: 25%;
          img, video, .no-data-des{
            width: 80%;
            height: 25vh;
            line-height: 25vh;
            margin: 0 10%;
          }
        }
        p{
          color: #333;
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          margin-top: 20px;
          cursor: pointer;
          width: 100%;
        }
        .no-data-des{
          display: inline-block;
          width: 100%;
          height: 17vh;
          line-height: 17vh;
          color: #333;
          font-size: 16px;
          //background: rgba(10, 14, 35, 0.5);
          background: #EEF0F5;
          margin:0 auto;
        }

      }

    }
  }
  .el-dialog{
    .image-box{
      img{
        width: 1102px;
        height: 672px;
      }
    }
  }
  .camera-wrap{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    display: none;
    .video-details-warp{
      position: absolute;
      top: 16%;
      left: 27%;
      padding: 20px;
      z-index: 999999;
      background: #12162b;
      p{
        color: #fff;
        font-size: 16px;
        margin: 0;
        width: 100%;
      }
      #myPlayer {
        margin-top: 25px;
        width: 850px;
        height: 570px;
        z-index: 999999;
      }
      span{
        color: #fff;
        position: absolute;
        top: 16px;
        right: 25px;
        z-index: 999999;
        cursor: pointer;
      }
    }
  }
}
</style>
